/**
 * ACCourses (Course Management) Services Module
 * Exports all course management services and factory functions
 */
// Export all service classes
export { ACCourseService } from './ACCourseService';
export { CourseDateService } from './CourseDateService';
export { CourseFileService } from './CourseFileService';
export { ACCourseSessionService } from './ACCourseSessionService';
export { CourseCustomFieldService } from './CourseCustomFieldService';
export { SessionCustomFieldService } from './SessionCustomFieldService';
export { FacilitatorService } from './FacilitatorService';
export { RegistrationService } from './RegistrationService';
export { AccoursesStreamingService } from './AccoursesStreamingService';
export { RegistrationIntakeService } from './RegistrationIntakeService';
export { ACCourseStatusService } from './ACCourseStatusService';
export { FacilitatorStatusService } from './FacilitatorStatusService';
export { RegistrationStatusService } from './RegistrationStatusService';
export { SessionStatusService } from './SessionStatusService';
export { SessionProgressStatusService } from './SessionProgressStatusService';
export { RegistrationIntakeStatusService } from './RegistrationIntakeStatusService';
export { ACCourseSettingService } from './ACCourseSettingService';
export { ACCourseNotificationChannelService } from './ACCourseNotificationChannelService';
export { FacilitatorPortalService } from './FacilitatorPortalService';
export { PublicCourseService } from './PublicCourseService';
export { PublicRegistrationIntakeService } from './PublicRegistrationIntakeService';
// Import for factory function
import { ACCourseService } from './ACCourseService';
import { CourseDateService } from './CourseDateService';
import { CourseFileService } from './CourseFileService';
import { ACCourseSessionService } from './ACCourseSessionService';
import { CourseCustomFieldService } from './CourseCustomFieldService';
import { SessionCustomFieldService } from './SessionCustomFieldService';
import { FacilitatorService } from './FacilitatorService';
import { RegistrationService } from './RegistrationService';
import { AccoursesStreamingService } from './AccoursesStreamingService';
import { RegistrationIntakeService } from './RegistrationIntakeService';
import { ACCourseStatusService } from './ACCourseStatusService';
import { FacilitatorStatusService } from './FacilitatorStatusService';
import { RegistrationStatusService } from './RegistrationStatusService';
import { SessionStatusService } from './SessionStatusService';
import { SessionProgressStatusService } from './SessionProgressStatusService';
import { RegistrationIntakeStatusService } from './RegistrationIntakeStatusService';
import { ACCourseSettingService } from './ACCourseSettingService';
import { ACCourseNotificationChannelService } from './ACCourseNotificationChannelService';
import { FacilitatorPortalService } from './FacilitatorPortalService';
import { PublicCourseService } from './PublicCourseService';
import { PublicRegistrationIntakeService } from './PublicRegistrationIntakeService';
/**
 * Create all course management services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all course management service instances
 */
export function createACCourseServices(http, config) {
    return {
        acCourse: new ACCourseService(http, config),
        courseDate: new CourseDateService(http, config),
        courseFile: new CourseFileService(http, config),
        acCourseSession: new ACCourseSessionService(http, config),
        courseCustomField: new CourseCustomFieldService(http, config),
        sessionCustomField: new SessionCustomFieldService(http, config),
        facilitator: new FacilitatorService(http, config),
        registration: new RegistrationService(http, config),
        registrationIntake: new RegistrationIntakeService(http, config),
        acCourseStatus: new ACCourseStatusService(http, config),
        facilitatorStatus: new FacilitatorStatusService(http, config),
        registrationStatus: new RegistrationStatusService(http, config),
        sessionStatus: new SessionStatusService(http, config),
        sessionProgressStatus: new SessionProgressStatusService(http, config),
        registrationIntakeStatus: new RegistrationIntakeStatusService(http, config),
        acCourseSetting: new ACCourseSettingService(http, config),
        acCourseNotificationChannel: new ACCourseNotificationChannelService(http, config),
        facilitatorPortal: new FacilitatorPortalService(http, config),
        publicCourse: new PublicCourseService(http, config),
        publicRegistrationIntake: new PublicRegistrationIntakeService(http, config),
        accoursesStreaming: new AccoursesStreamingService(http),
    };
}
//# sourceMappingURL=index.js.map